import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const setBucketTime = (bucket: string, time: string) => ({
  type: types.SET_BUCKET_TIME,
  bucket,
  time,
});

export const setLegends = legends => ({
  type: types.SET_LEGENDS,
  legends,
});

export const resetLegends = () => ({
  type: types.RESET_LEGENDS,
});

export const setHighlightBucket = bucket => ({
  type: types.SET_HIGHLIGHT_BUCKET,
  bucket,
});

export const restBucketTime = () => ({
  type: types.REST_BUCKET_TIME,
});

export const injectSharedState = sharing => ({
  type: types.INJECT_SHARED_STATE,
  sharing,
});

const {
  init: initDistributionRequest,
  fetching: fetchingDistribution,
} = createAllActions(types.SCOPE);

export {
  initDistributionRequest,
  fetchingDistribution,
};
